import { ChangeEventHandler, memo, useState } from 'react';

import { clsx } from 'clsx';

import cls from './CountInput.module.scss';

export type CountInputProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  size?: 's' | 'm';
  className?: string;
};

export const CountInput = memo<CountInputProps>(({ value, onChange, size = 'm', min = 0, className }) => {
  const [inputValue, setInputValue] = useState(value);

  const disabledDecrementButton = value === min;

  const handleChangeInput: ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = event.target.value;

    if (!value) {
      setInputValue(min);
      onChange(min);
    } else if (!value.match(/[^0-9]/) && +value >= min) {
      onChange(+value);
      setInputValue(+value);
    }
  };

  const handleClickIncrement = () => {
    const newValue = inputValue + 1;
    onChange(newValue);
    setInputValue(newValue);
  };

  const handleClickDecrement = () => {
    const newValue = inputValue - 1;

    if (value > min) {
      onChange(newValue);
      setInputValue(newValue);
    }
  };

  return (
    <div className={clsx(cls.wrapper, className, [cls[size]])}>
      <button
        className={clsx(cls.button, { [cls.disabled]: disabledDecrementButton })}
        disabled={value === min}
        onClick={handleClickDecrement}
      >
        -
      </button>
      <input
        value={inputValue}
        onChange={handleChangeInput}
      />
      <button
        className={cls.button}
        onClick={handleClickIncrement}
      >
        +
      </button>
    </div>
  );
});
